export enum ColorCodes {
    sceneBackground = "#F0FBFF",
    pointLight = "#FFFFFF",
    red = "#E64A4A", // invalids and collision highlight
    black = "#0A0A0A", // shapes edges color
    white = "#FFFFFF", // selection highlight
    transparentBlue = "#ADD8E6", // valids
    darkRed = "#8B0000", // hole wireframe
    lightGray = "#EEEEEE", // mini scene bgs
}

export type ColorPickerOption = {
    name: string;
    value: string;
};

export const ColorsPicker: ColorPickerOption[] = [
    { name: "Dark Green", value: "#117A65" },
    { name: "Bright Green", value: "#21BA45" },
    { name: "Sky Blue", value: "#5DADE2" },
    { name: "Vivid Violet", value: "#3633BF" },
    { name: "Burnt Orange", value: "#CF871B" },
    { name: "Aqua Teal", value: "#00B5AD" },
    { name: "Light Blue", value: "#2185D0" },
    { name: "Steel Blue", value: "#3C79B7" },
    { name: "White", value: "#FFFFFF" },
    { name: "Red", value: "#FF0000" },
    { name: "Yellow", value: "#FFFF00" },
    { name: "Magenta", value: "#FF00FF" },
    { name: "Gray", value: "#808080" },
    { name: "Dim", value: "#ACACAC" },
    { name: "Dark Grey", value: "#6B6B6B" },
];
